import type { StatusDocument } from '@/constants/status';

import type { DataTableResponse } from '../response';

export interface VendorMainDataResponse {
	id: number;
	name: string;
	email: string;
	company_id: number | null;
	business_area_id: number | null;
	business_area_name: string | null;
	qualification_id: number | null;
	qualification_name: string | null;
	website: string | null;
	type_cooperations?:
		| {
				id: number | null,
				name: string | null
		  }[]
		| undefined;
	phone_number: string | null;
	address: string | null;
	province_id: string | null;
	province_name: string | null;
	city_id: string | null;
	city_name: string | null;
	district_id: string | null;
	district_name: string | null;
	village_id: string | null;
	village_name: string | null;
	postal_code: string | null;
	npwp: string | null;
	npwp_name: string | null;
	npwp_address: string | null;
	npwp_file_name: string | null;
	pic_name: string | null;
	pic_email: string | null;
	pic_phone_number: string | null;
	pic_nik: string | null;

	photo: string | null;
	cover: string | null;
	status: StatusDocument;
}

export interface VendorBankDataResponse {
	id: number;
	bankId: number;
	bankCode: string;
	accountName: string;
	accountNumber: string;
	bankName: string;
	image: string;
}

export interface VendorSegmentationDataResponse {
	id: number;
	businessFieldId: number;
	subBusinessFieldId: number;
	businessFieldName: string | null;
	subBusinessFieldName: string | null;
}

export type DocumentId =
	| 'D001' // Akta Perubahan
	| 'D002' // PKP or Non PKP
	| 'D003' // Salinan SK dan/atau Penerimaan Pemberitahuan Menkumham
	| 'D004' // Akta Salinan Pendirian Perusahaan
	| 'D005' // Data Bukti Fisik Perusahaan
	| 'D006' // Nomor Induk Berusaha (NIB) OSS RBA
	| 'D007' // Surat Izin Usaha Khusus
	| 'D008' // Surat Pernyataan Bebas Konflik Kepentingan
	| 'D009' // Surat Pernyataan Kebenaran Dokumen
	| 'D0010'; // Dokumen Pendukung Lainnya

type DocumentType = {
	type: 'image' | 'pdf',
	max: number,
	format?: 'link',
	isRequired: (value?: string) => boolean
};
export const DOCUMENT: Record<DocumentId, DocumentType> = {
	D001: { type: 'pdf', max: 10, isRequired: (value) => value === 'yes' },
	D002: { type: 'pdf', max: 10, isRequired: () => true },
	D003: { type: 'pdf', max: 10, isRequired: () => true },
	D004: { type: 'pdf', max: 10, isRequired: () => true },
	D005: { type: 'image', max: 10, isRequired: () => true },
	D006: { type: 'pdf', max: 1, isRequired: () => true },
	D007: { type: 'pdf', max: 1, isRequired: () => false },
	D008: { type: 'pdf', max: 1, isRequired: () => true, format: 'link' },
	D009: { type: 'pdf', max: 1, isRequired: () => true, format: 'link' },
	D0010: { type: 'pdf', max: 10, isRequired: () => false }
};

export interface VendorDocumentDataResponse {
	id: DocumentId;
	vendorDocumentId: number;
	vendorId: number;
	name: string;
	description: string | null;
	required: boolean;
	value: string | null;
	statusId: StatusDocument;
	statusName: string;
	status: {
		text: string,
		text_color: string,
		text_background_color: string
	};
	remarks?: string;
	files: {
		id: number,
		fileName: string,
		documentNumber: string,
		startDate: string,
		endDate: string
	}[];
	history?: {
		id: number,
		vendorId: number,
		vendorDocumentId: number,
		statusId: StatusDocument,
		typeId: string,
		remarks: string | null,
		userId: number,
		createdDate: string
	};
	action?: 'approved' | 'pending' | null;
}
export interface VendorPicDataResponse {
	id: number;
	name: string;
	statusId: string;
	phoneNumber: string;
	vendorId: number;
	occupationId: number;
	positionId: number;
	nik: string;
	email: string;
	birthDate: string;
	selfieFile: string;
	ktpFile: string;
	positionName: string;
	occupationName: string;
	statusName: string;
}

export interface VendorSectionStatus {
	hasLogin: boolean;
	hasMainData: boolean;
	hasBankData: boolean;
	hasSegmentationData: boolean;
	hasPersonResponsibleData: boolean;
	hasDocumentData: boolean;
	canSendRequest: boolean;
	canResubmitRequest: boolean;
}

export interface VendorDetail {
	login: { id: number, fullName: string, email: string };
	main: VendorMainDataResponse;
	bank: DataTableResponse<VendorBankDataResponse>;
	segmentation: DataTableResponse<VendorSegmentationDataResponse>;
	personResponsible: DataTableResponse<VendorPicDataResponse>;
	canContinue: boolean;
}
